<template>
    <div class="comments-row" id="comments">
        <div class="comments-title-row">
            最新评论
            <div class="comments-reverse">
            <i v-if="data.is_reverse" class="iconfont icon-sort_down" @click="data.is_reverse = !data.is_reverse"></i>
            <i v-else class="iconfont icon-sort_up" @click="data.is_reverse = !data.is_reverse"></i>
            </div>
            <button class="btn btn-info" @click="addComment">添加评论</button>
        </div>
        <div v-for="(comment,index) in data.comments" class="commentItem">
            <div class="comment-panel">
            <div class="comment-user-image-container">
                <a :href="'/dynamics/' + comment.user.user_id + '.html'">
                    <img v-if="comment.is_against" class="user-against" :src="comment.user.head">
                    <img v-else :src="comment.user.head" class="user-agree"/>
                </a>
            </div>
                <div class="comment-content-container">
                    <div class="comment-content-user">
                        <a :href="'/dynamics/'+ comment.user.user_id + '.html'">
                            <div class="comment-user-name" v-text="comment.user.nickname"></div>
                        </a>
                        <div class="comment-approve">
                            <i :class="comment.is_follow == 0? '' :'color-orange'" :data-comid="comment.com_id" 
                            :id="comment.id" :data-id="comment.id" @click="likeComment" class="iconfont icon-nice"></i>
                            <span v-show="comment.follow > 0" class="comment-follow-num" v-text="comment.follow"></span>
                        </div>
                    </div>
                    <div class="comment-content" v-text="comment.comment"></div>

                    <div v-if="comment.sonComment" class="comment-reps">
                        <div v-for="comment in comment.sonComment" class="row comment-rep-content-container">
                            <div class="col-xs-1 comment-rep-user-image-container">
                                <a :href="'/dynamics/'+ comment.user.user_id + '.html'">
                                <img v-if="comment.is_against == true" class="user-against" :src="comment.user.head"/>
                                <img v-else class="user-agree" :src="comment.user.head"/>
                                </a>
                            </div>
                            <div class="col-xs-10 comment-rep-content-text-container">
                                <div class="comment-content-user">
                                    <div class="comment-rep-info">
                                    <a :href="'/dynamics/' + comment.user.user_id + '.html'">
                                        <span class="comment-rep-user-name" v-text="comment.user.nickname"></span>
                                        [<span class="comment-rep-time" v-text="comment.created_at"></span>]
                                    </a>
                                    </div>
                                </div>
                                <div class="comment-rep-content" v-text="comment.comment"></div>
                            </div>
                            <div class="col-xs-1">
                                <div class="comment-approve">
                                    <i :class="comment.is_follow == 0? '' :'color-orange'" :data-comid="comment.com_id" 
                                    :id="comment.id" :data-id="comment.id" @click="likeComment" class="iconfont icon-nice"></i>
                                    <span v-show="comment.follow > 0" class="comment-follow-num" v-text="comment.follow"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="comment-info">
                        <span v-text="comment.created_at"></span>
                        <span v-if="comment.id" data-sendid="0" @click="repComment" :id="comment.id" :data-id="comment.id" class="comment-rep-btn"> · 回复</span>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="data.add_com.show_panel" :title="data.add_com.title" class="comment-input-panel">
            <div v-if="data.add_com.com_id > 0" class="input-father-comment"
                v-text="data.comments[data.add_com.com_id].comment"></div>
            <el-input v-model="data.add_com.com_text" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea" placeholder="请输入评论..."
            show-word-limit maxlength="100"/>
            <template #footer>
                <span class="dialog-footer">
                    <el-form-item :label="data.add_com.support_text">
                        <el-switch v-model="data.add_com.support"/>
                    </el-form-item>
                    <el-button @click="data.add_com.show_panel = false">取消</el-button>
                    <el-button type="primary" @click="sendComment">确认</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script src="./comments.vue.js"></script>
<style scoped>
/**********用户评论版块**********/
.iconfont.icon-nice{
    color: #666;
    cursor: pointer;
}
.iconfont.icon-nice.color-orange{
    color: orange;
}
.comments-row {
    padding: 15px;
    width: 100%;
    margin: auto 0 0 0;
}
.comments-row .comments-title-row{
    font-size: 18px;
    line-height: 30px;
    margin-top: 50px;
    margin-bottom: 50px;
    color: #E23F4C;
    border-left: 5px solid #E23F4C;
    padding-left: 10px;
    font-weight: 600;
}
.comments-reverse{
    display: inline-block;
}
.comments-reverse i{
    font-weight: 400;
    padding-left: 6px;
    top: 3px;
    position: relative;
}
.comments-row .comments-title-row button{
    float: right;
    margin-right: 40px;
    padding: 7px 30px;
}
.comment-input-panel .el-form-item
{
    float: left;
}
.comment-input-panel .el-textarea__inner
{
    font-size: 15px;
    line-height: 25px;
}
.comment-input-panel .input-father-comment{
    font-size: 15px;
    line-height: 30px;
    padding-bottom: 10px;
}
.comment-input-panel .el-dialog__body{
    padding-top: 10px;
    padding-bottom: 10px;
}
.commentItem {
    background-color: #fff;
    /*border-bottom: 2px dashed #E2E2E2;*/
}

.user-agree
{    
    height: 60px;
    width: 60px;
    border: 2px solid #00ff00;
    border-radius: 50%;
}
.user-against
{    
    height: 60px;
    width: 60px;
    border: 2px solid #ff0000;
    border-radius: 50%;
}
.comment-panel{
  display: flex;
  margin-top: 10px;
}
.comment-user-image-container{
    padding: 2px 12px 2px 2px;
    width: 10%;
    text-align: center;
}

.comment-user-image-container a img{
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.comment-content-container{
  width: 85%;
}
.comment-content-user{
  font-size: 16px;
  color: #406599;
  display: flex;
  width:100%;
}
.comment-content-user a{
  width: 80%;
  text-decoration: none;
}
.comment-user-name{
    width: 300px;
    max-width: 300px;
    overflow: hidden;
}
.comment-approve{
  width: 20%;
  text-align: right;
}
.comment-follow-num
{
    position: relative;
    top: -10px;
}
.comment-content{
  margin-top: 1rem;
  word-wrap: break-word;
  color: #222;
  text-align: justify;
  widows: 95%;
}
.comment-info{
  font-size: 12px;
  text-align: right;
  margin: 6px;
}

/*回复模块*/
.comment-reps{
  /*display: flex;*/
  border-top: #999 1px dashed;
  margin: 6px 0;
}
.comment-rep-user-image-container{
  padding: 2px;
  display: inline-block;
  text-align: center;
}
.comment-rep-user-image-container img{
  width: 90%;
  height: auto;
  min-height: 40px;
  border-radius: 50%;
}
.comment-rep-content-text-container
{
    display: inline-block;
}
.comment-rep-info a{
  max-width: 40%;
}
.comment-rep-user-name{
  max-width: 40%;
}
.comment-rep-info{
  width: 80%;
}
.comment-rep-content-container{
  border-bottom: #ccc 0.5px dashed;
  padding: 10px;
}
.comment-rep-time{
  font-size: 10px;
  color: #333;
}
.comment-rep-content{
    font-size: 14px;
    margin-top: 12px;
    word-wrap: break-word;
    text-align: justify;
}
.comment-rep-btn
{
    cursor: pointer;
    color: #2d64b3;
}
</style>